import {
  Box,
  Container,
  Heading,
  Text,
  Image,
  Stack,
  Button,
  SimpleGrid,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import PannerImage from "./images/panner1.png";
import HeroImage from "./images/stamps.png";

const PannerDescription = () => {
  const navigate = useNavigate();

  return (
    <Box>
      <Navbar />

      {/* Background image */}
      <Image
        src={HeroImage}
        alt="Hero Watermark"
        width="100%"
        height="100%"
        objectFit="cover"
        opacity={0.30}
        position="absolute"
        top={0}
        left={0}
        zIndex={-1}
        filter="blur(1px)"
      />

      <Container maxW="container.xl" py={8}>
        <Stack spacing={8} align="stretch">
          {/* Header Section */}
          <Box
            bg="rgba(255,255,255,0.95)"
            p={12}
            borderRadius="lg"
            boxShadow="xl"
            textAlign="center"
          >
            <Image
              src={PannerImage}
              alt="Panner"
              maxW="400px"
              mx="auto"
              mb={6}
            />
          </Box>

          {/* Main Content */}
          <Box
            bg="rgba(255,255,255,0.95)"
            p={10}
            borderRadius="lg"
            boxShadow="xl"
          >
            <Heading size="lg" mb={6} color="gray.800">
              From Placement to Policy
            </Heading>

            <Text fontSize="lg" mb={6} lineHeight="1.8" color="gray.700">
              Bridge placement and accounting processes with intelligent allocation and streamlined workflows.
            </Text>

            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={8} mb={8}>
              <Box>
                <Heading size="lg" color="green.600" mb={4}>
                  Key Capabilities
                </Heading>
                <Stack spacing={4}>
                  <Box p={4} bg="green.50" borderRadius="md">
                    <Text color="gray.700" fontSize="md">
                      Placement to accounting coordination
                    </Text>
                  </Box>

                  <Box p={4} bg="green.50" borderRadius="md">
                    <Text color="gray.700" fontSize="md">
                      Configurable distribution management
                    </Text>
                  </Box>

                  <Box p={4} bg="green.50" borderRadius="md">
                    <Text color="gray.700" fontSize="md">
                      Platform integration
                    </Text>
                  </Box>

                  <Box p={4} bg="green.50" borderRadius="md">
                    <Text color="gray.700" fontSize="md">
                      Streamlined claims handling
                    </Text>
                  </Box>
                </Stack>
              </Box>

              <Box>
                <Heading size="lg" color="green.600" mb={4}>
                  Features
                </Heading>
                <Stack spacing={4}>
                  <Box p={4} bg="green.50" borderRadius="md">
                    <Text color="gray.700" fontSize="md">
                      Cross-functional data translation
                    </Text>
                  </Box>

                  <Box p={4} bg="green.50" borderRadius="md">
                    <Text color="gray.700" fontSize="md">
                      Complete audit trail and segmentation
                    </Text>
                  </Box>
                </Stack>
              </Box>
            </SimpleGrid>

            <Box textAlign="center" mt={8}>
              <Button
                colorScheme="green"
                size="lg"
                onClick={() => navigate("/panner")}
                boxShadow="lg"
                _hover={{ transform: "scale(1.05)" }}
                transition="all 0.2s"
              >
                Launch Panner
              </Button>
            </Box>
          </Box>

        </Stack>
      </Container>
    </Box>
  );
};

export default PannerDescription;
